import React from "react";
import { Typography } from "@mui/material";

const ErrorMessage = ({ message }) => {
    return (
        <Typography color="error" sx={{ mt: 2 }}>
            {message}
        </Typography>
    );
};

export default ErrorMessage;